import saveAs from 'file-saver';

export interface IDownloadArquivoDeBase64Parametros {
  base64: string;
  nomeArquivo?: string;
  tipo: 'application/pdf' | 'text/csv';
}

export const downloadArquivoDeBase64 = ({
  base64,
  nomeArquivo,
  tipo
}: IDownloadArquivoDeBase64Parametros) => {
  const base64Decodificada = atob(base64);
  if (tipo === 'application/pdf') {
    const rawLength = base64Decodificada.length;
    const uint8Array = new Uint8Array(new ArrayBuffer(rawLength));
    for (let i = 0; i < rawLength; i++) {
      uint8Array[i] = base64Decodificada.charCodeAt(i);
    }

    const blob = new Blob([uint8Array], { type: tipo });
    saveAs(blob, nomeArquivo);
    return;
  }

  const blob = new Blob([base64Decodificada], { type: tipo });
  saveAs(blob, nomeArquivo);
};
